export default __webpack_public_path__ + "static/media/slubny-przewodnik.98a6fd64.md";